import { CalendarDays } from "lucide-react";

/**
 * 비로그인(게스트) 학습 일정 정적 목업 (JCG-2310).
 *
 * 실제 ScheduleCalendar 의 시각 골격(헤더 뷰 토글 + 범례 + 주 보드 7칼럼)을 더미 데이터로 본뜬
 * presentational 컴포넌트. fetch/훅 없음 — GuestPreviewOverlay 가 통째로 aria-hidden + blur 처리하므로
 * 시각 골격만 신경 쓴다(StudyProgressGuestMock 패턴과 동일). 색은 디자인 토큰 + amber + 계획 계열색.
 */
export default function ScheduleGuestMock() {
  const days = [
    { wd: "월", d: 6, dots: [{ c: "blue", done: true }] },
    { wd: "화", d: 7, dots: [{ c: "blue", done: false }] },
    { wd: "수", d: 8, exam: true, dots: [{ c: "amber", done: false }] },
    { wd: "목", d: 9, today: true, dots: [{ c: "green", done: false }] },
    { wd: "금", d: 10, dots: [] },
    { wd: "토", d: 11, dots: [] },
    { wd: "일", d: 12, dots: [] },
  ];

  return (
    <div className="px-1 py-2">
      <div className="mb-4 flex items-center gap-2">
        <CalendarDays className="h-5 w-5 text-amber-500" />
        <h2 className="text-xl font-bold text-foreground">학습 일정</h2>
      </div>

      {/* 헤더 mock */}
      <div className="mb-3 flex items-center justify-between">
        <div className="inline-flex rounded-lg border border-border p-0.5 text-sm">
          <span className="rounded-md bg-amber-500 px-3 py-1 font-medium text-white dark:bg-amber-400 dark:text-amber-950">
            주
          </span>
          <span className="px-3 py-1 font-medium text-muted-foreground">월</span>
        </div>
        <div className="flex items-center gap-2.5 text-[11px] text-muted-foreground">
          <span className="flex items-center gap-1">
            <span className="h-2 w-2 rounded-full bg-blue-500 dark:bg-blue-400" />
            이론
          </span>
          <span className="flex items-center gap-1">
            <span className="h-2 w-2 rounded-full bg-green-500 dark:bg-green-400" />
            코딩
          </span>
        </div>
      </div>

      <div className="mb-3 flex items-center gap-2">
        <span className="text-base font-bold text-foreground">7/6 – 7/12</span>
        <span className="text-[11px] text-muted-foreground">Day 10~14</span>
      </div>

      {/* 주 보드 mock(7칼럼) */}
      <div className="grid grid-cols-7 gap-2">
        {days.map((day) => (
          <div
            key={day.wd}
            className={[
              "flex min-h-[7rem] flex-col rounded-xl border",
              day.today
                ? "border-amber-400 dark:border-amber-500"
                : "border-border",
              day.exam ? "bg-amber-50/40 dark:bg-amber-950/20" : "",
            ].join(" ")}
          >
            <div
              className={[
                "flex items-center justify-between rounded-t-xl px-2 py-1.5 text-[11px] font-semibold",
                day.today
                  ? "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300"
                  : "text-muted-foreground",
              ].join(" ")}
            >
              <span className="flex items-center gap-1">
                {day.wd}
                <span className="tabular-nums">{day.d}</span>
              </span>
            </div>
            <div className="flex flex-1 flex-col gap-1.5 p-1.5">
              {day.dots.map((dot, i) => (
                <div
                  key={i}
                  className="flex items-center gap-1.5 overflow-hidden rounded-lg border border-border bg-card py-1.5 pl-0 shadow-sm"
                >
                  <span
                    className={[
                      "h-full w-1 self-stretch",
                      dot.c === "blue"
                        ? "bg-blue-400 dark:bg-blue-500"
                        : dot.c === "green"
                          ? "bg-green-400 dark:bg-green-500"
                          : "bg-amber-400 dark:bg-amber-500",
                    ].join(" ")}
                  />
                  <span className="h-2.5 w-12 rounded bg-muted" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
